import React from 'react';
import { authRoles } from 'app/auth';

// Feature: heidi-training - self-service model fine-tuning on a Heidi cluster.
// A workshop participant's role array also carries 'user' (see passport/auth.js),
// so FuseUtils.hasPermission's OR-match already lets them reach this route -
// no excludeArr here, deliberately. Whether a participant can actually DO
// anything on it is enforced server-side by the api's training_job:*
// permission, gated per-workshop on Training.allowParticipantTraining
// (authz/index.js's participant branch) - off by default, since this submits
// unattended, multi-hour GPU jobs shared with the rest of the workshop.
export const HeidiTrainingConfig = {
	settings: { layout: { config: {} } },
	auth: [...authRoles.user, ...authRoles.instructor],
	routes: [
		{
			path: '/training-jobs/new',
			component: React.lazy(() => import('./NewTrainingRunPage')),
		},
		{
			path: '/training-jobs/models',
			component: React.lazy(() => import('./ModelsPage')),
		},
		{
			path: '/training-jobs/registry',
			component: React.lazy(() => import('./RegistryPage')),
		},
		{
			path: '/training-jobs/:id',
			component: React.lazy(() => import('./TrainingRunDetailPage')),
		},
		{
			path: '/training-jobs',
			exact: true,
			component: React.lazy(() => import('./TrainingRunsPage')),
		},
	],
};
